import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import {
  getListInvoiceListingCount,
  getDetailInvoice,
  getListVoucher,
  getListInvoice,
  getDetailInvoiceV2,
  getListInvoiceV2,
  getInvoiceDetail
} from "./api"

export const useGetListInvoiceListingCount = ({ params }) => {
  return useQuery({
    queryKey: ['get-list-invoice-listing-count', params],
    queryFn: () => getListInvoiceListingCount(params),
  })
}

export const useGetDetailInvoice = ({ id }) => {
  return useQuery({
    queryKey: ['get-detail-invoice', id],
    queryFn: () => getDetailInvoice(id),
  })
}

export const useGetListVoucher = ({ params, options }) => {
  return useQuery({
    queryKey: ['get-list-voucher', params],
    queryFn: () => getListVoucher(params),
    ...options,
  })
}

export const useGetInvoiceList = ({ params }) => {
  return useInfiniteQuery({
    queryKey: ['get-invoice-list', params],
    queryFn: ({ pageParam = 1 }) => getListInvoice({...params, page: pageParam}),
    getNextPageParam: (lastPage) => {
      return !!lastPage?.data?.data?.length ? +lastPage.headers["x-page"] + 1 : undefined
    },
  })
}

export const useGetInvoiceDetail = ({ id, enabled }) => {
  return useQuery({
    queryKey: ['get-detail-invoice-v2', id],
    queryFn: () => getInvoiceDetail(id),
    enabled
  })
}


export const useGetDetailInvoiceV2 = ({ params, enabled }) => {
  return useQuery({
    queryKey: ['get-detail-invoice-v2', params],
    queryFn: () => getDetailInvoiceV2(params),
    enabled
  })
}

export const useGetInvoiceListV2 = ({ params }) => {
  return useInfiniteQuery({
    queryKey: ['get-invoice-list-v2', params],
    queryFn: ({ pageParam = 1 }) => getListInvoiceV2({...params, page: pageParam}),
    getNextPageParam: (lastPage) => {
      return !!lastPage?.data?.data?.length ? +lastPage.headers["x-page"] + 1 : undefined
    },
  })
}